import { useState } from "react";
import { ICatalog } from "../../../../types";
import api from "../../../../api";
import styles from "./index.module.scss";
import { useFormik } from "formik";
import { useAppDispatch } from "../../../../redux/hooks";
import { deleteCatalog, getCatalogsByType } from "../../../../redux/reducers";

const CatalogRow = ({
  amount,
  catalogId,
  catalogName,
  catalogType,
  description,
  image,
  price,
}: ICatalog) => {
  const [changeble, setIsChangable] = useState<boolean>(false);
  const [state, setState] = useState(false);
  const [catalogRow, setCatalogRow] = useState({
    amount,
    catalogId,
    catalogName,
    catalogType,
    description,
    image,
    price,
  });
  const dispatch = useAppDispatch();

  return changeble ? (
    <tr className={styles.root}>
      <th>
        <input
          type="text"
          value={catalogName}
          onChange={(e) => {
            setCatalogRow({ ...catalogRow, catalogName: e.target.value });
          }}
          name=""
          id="catalogName"
        />
      </th>
      <th>
        <input
          type="text"
          value={description}
          onChange={(e) => {
            setCatalogRow({ ...catalogRow, description: e.target.value });
          }}
          name=""
          id=""
        />
      </th>
      <th>
        <input
          type="number"
          onChange={(e) => {
            setCatalogRow({ ...catalogRow, price: Number(e.target.value) });
          }}
          value={price}
          name=""
          id="price"
        />{" "}
      </th>
      <th>
        <input type="number" value={amount} name="" id="amount" />
      </th>
      <th>
        <form action="">
          <input type="file" name="" id="" />
        </form>
      </th>
      <th className={styles.action}>
        <button
          onClick={() => {
            setIsChangable(true);
          }}
        >
          Сохранить
        </button>
        <button
          onClick={() => {
            setIsChangable(false);
          }}
        >
          Отменить
        </button>
      </th>
    </tr>
  ) : (
    <tr className={styles.root}>
      <th>{catalogName}</th>
      <th>{description}</th>
      <th>{price} </th>
      <th>{amount}</th>
      <th>
        <img src={image.imagePath} alt="Нету фотографии" />
      </th>
      <th className={styles.action}>
        <button
          onClick={() => {
            dispatch(deleteCatalog(catalogId));
          }}
        >
          Удалить{" "}
        </button>
        <button
          onClick={() => {
            setIsChangable(true);
          }}
        >
          Изменить
        </button>
      </th>
    </tr>
  );
};

export default CatalogRow;
